<template>
  <div class="prevention">
    <h1>Профилактика</h1>
    <div class="container">
      <div class="prevention-elements">
        <div class="prevention-element">
          <div class="prevention-element-icon"><Preven1/><Green class="prevention-element-icon__right"/></div>
          <span class="prevention-element-text">Использовать средства защиты - маска, перчатки</span>
        </div>
        <div class="prevention-element">
          <div class="prevention-element-icon"><Preven2/><Red class="prevention-element-icon__right"/></div>
          <span class="prevention-element-text">Избегать посещения общественных мест, скопления людей</span>
        </div>
        <div class="prevention-element">
          <div class="prevention-element-icon"><Preven3/><Red class="prevention-element-icon__right"/></div>
          <span class="prevention-element-text">Избегать близких контактов с людьми имеющими признаки ОРВИ</span>
        </div>
      </div>
      <div class="prevention-elements">
        <div class="prevention-element">
          <div class="prevention-element-icon"><Preven4/><Red class="prevention-element-icon__right"/></div>
          <span class="prevention-element-text">Не касаться руками глаз, лица, рта</span>
        </div>
        <div class="prevention-element">
          <div class="prevention-element-icon"><Preven5/><Green class="prevention-element-icon__right"/></div>
          <span class="prevention-element-text">Мыть руки с мылом, использовать антисептик</span>
        </div>
        <div class="prevention-element">
          <div class="prevention-element-icon"><Preven6/><Green class="prevention-element-icon__right"/></div>
          <span class="prevention-element-text">Дезинфицировать гаджеты и поверхности которыми прикасаетесь</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Preven1 from '@/assets/svg/infographics/preven-icon1.svg';
import Preven2 from '@/assets/svg/infographics/preven-icon2.svg';
import Preven3 from '@/assets/svg/infographics/preven-icon3.svg';
import Preven4 from '@/assets/svg/infographics/preven-icon4.svg';
import Preven5 from '@/assets/svg/infographics/preven-icon5.svg';
import Preven6 from '@/assets/svg/infographics/preven-icon6.svg';
import Green from '@/assets/svg/infographics/green.svg';
import Red from '@/assets/svg/infographics/red.svg';

export default {
  components: {
    Preven1,
    Preven2,
    Preven3,
    Preven4,
    Preven5,
    Preven6,
    Green,
    Red
  }
}
</script>

<style lang="scss" scoped>
.prevention {
  background: url('/images/prevention.jpg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 60px 0;
  & h1 {
    color: #fff;
  }
  &-elements {
    display: flex;
    justify-content: space-between;
    margin-top: 105px;
  }
  &-element {
    width: 32%;
    border-radius: 3px;
    background-color: #ffffff;
    padding: 25px;
    padding: 0 42px;
    padding-top: 93px;
    height: 169px;
    position: relative;
    &-icon {
      border-radius: 50%;
      width: 146px;
      height: 146px;
      left: 50%;
      margin-left: -73px;
      top: -73px;
      position: absolute;
      box-shadow: 0 3px 22px rgba(82, 121, 146, 0.34);
      &__right {
        position: absolute;
        right: 0;
        top: 0;
      }
    }
    &-text {
      display: block;
      text-align: center;
      font-size: 15px;
    }
  }
}
@media screen and (max-width: 767px) {
  .prevention {
    padding: 50px 0;
    &__title {
      font-size: 25px;
    }
    &__subtitle {
      font-size: 25px;
    }
    &-elements {
      flex-wrap: wrap;
    }
    &-element {
      margin: 0 auto;
      width: 100%;
      margin-bottom: 95px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>